import { Link } from 'react-router-dom';
import { Clock, MapPin, Users, Gift, ChevronRight } from 'lucide-react';
import CountdownTimer from './CountdownTimer';

const GiveawayCard = ({ giveaway }) => {
  const formatValue = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  return (
    <Link to={`/giveaways/${giveaway.giveaway_id}`} data-testid={`giveaway-card-${giveaway.giveaway_id}`}>
      <div className="group bg-white border border-neutral-200 rounded-2xl overflow-hidden hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300">
        {/* Image */}
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={giveaway.image_url || 'https://images.unsplash.com/photo-1772567732969-c1506edf80a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBraXRjaGVuJTIwcmVtb2RlbHxlbnwwfHx8fDE3NzQ1Mjg5MzV8MA&ixlib=rb-4.1.0&q=85'}
            alt={giveaway.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          
          {/* Value Badge */}
          <div className="absolute top-4 left-4 bg-black/80 backdrop-blur-sm text-white font-bold px-3 py-1.5 rounded-full text-sm">
            {formatValue(giveaway.value)} Value
          </div>
          
          {/* Free Entry Badge */}
          <div className="absolute top-4 right-4 bg-green-500 text-white font-bold px-3 py-1.5 rounded-full text-xs uppercase tracking-wider">
            Free Entry
          </div>

          {/* Featured Badge */}
          {giveaway.featured && (
            <div className="absolute bottom-4 left-4 bg-[#FF3B30] text-white font-semibold px-3 py-1.5 rounded-full text-xs uppercase">
              Featured
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-5">
          <div className="flex items-center gap-2 text-neutral-500 text-sm mb-2">
            <MapPin className="w-4 h-4" />
            <span>{giveaway.city}, {giveaway.province_state}</span>
          </div>
          
          <h3 className="font-semibold text-lg text-neutral-900 mb-3 line-clamp-2 group-hover:text-[#FF3B30] transition-colors" style={{ fontFamily: 'Outfit' }}>
            {giveaway.title}
          </h3>

          {/* Stats */}
          <div className="flex items-center gap-4 text-sm text-neutral-500 mb-4">
            <div className="flex items-center gap-1.5">
              <Users className="w-4 h-4" />
              <span>{giveaway.total_entries || 0} entries</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Gift className="w-4 h-4" />
              <span>{giveaway.sponsors?.length || 0} sponsors</span>
            </div>
          </div>

          {/* Countdown */}
          <div className="flex items-center justify-between pt-4 border-t border-neutral-100">
            <div className="flex items-center gap-2 text-sm">
              <Clock className="w-4 h-4 text-[#FF3B30]" />
              <CountdownTimer endDate={giveaway.end_date} compact />
            </div>
            <ChevronRight className="w-5 h-5 text-neutral-400 group-hover:text-[#FF3B30] group-hover:translate-x-1 transition-all" />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default GiveawayCard;
